import picVideo from './pic&video'
export default {
  components: { picVideo },
  data() {
    return {
      rowData: {},
      viewType: '',
      picVideoVisible: false
    }
  },
  methods: {
    showDialog(rowData, type) {
      this.rowData = rowData;
      this.viewType = type;
      this.picVideoVisible = true;
    },
    // 显示查看图片、视频按钮
    showDetailBtn(rowData) {
      if (!rowData.imgUrlList || !rowData.imgUrlList.length) {
        return false;
      }else{
        return true;
      }
    }
  }
}